import { useState, useRef, useEffect } from "react";

const CalendarIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke="#98A2B3" strokeWidth="1.5" />
        <path d="M3 9H21" stroke="#98A2B3" strokeWidth="1.5" />
        <path d="M8 3V6" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 3V6" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const ChevronDownIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#6941C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function DateRangeFilter({ dateFrom, dateTo, onChange }) {
    const [open, setOpen] = useState(false);
    const [localFrom, setLocalFrom] = useState(dateFrom || "");
    const [localTo, setLocalTo] = useState(dateTo || "");
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel =
        dateFrom && dateTo ? `${dateFrom} → ${dateTo}` : dateFrom || dateTo ? "Custom" : "All";

    const handleApply = () => {
        onChange({ dateFrom: localFrom, dateTo: localTo });
        setOpen(false);
    };

    const handleClear = () => {
        setLocalFrom("");
        setLocalTo("");
        onChange({ dateFrom: "", dateTo: "" });
        setOpen(false);
    };

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen((v) => !v)}
                className="flex items-center gap-2 border border-[#D0D5DD] rounded-full px-4 py-2 text-sm whitespace-nowrap"
            >
                <CalendarIcon />
                <span className="text-[#344054]">Date</span>
                <span className="text-[#6941C6] font-medium">{selectedLabel}</span>
                <ChevronDownIcon />
            </button>

            {open && (
                <div className="absolute right-0 mt-2 w-[280px] bg-white border border-[#EAECF0] rounded-lg shadow-lg z-10 p-4">          <div className="flex flex-col gap-3">
                    <div>
                        <label className="block text-[12px] font-medium text-[#344054] mb-1">Date from</label>
                        <input
                            type="date"
                            value={localFrom}
                            onChange={(e) => setLocalFrom(e.target.value)}
                            className="w-full border border-[#D0D5DD] rounded-md px-3 py-2 text-sm"
                        />
                    </div>
                    <div>
                        <label className="block text-[12px] font-medium text-[#344054] mb-1">Date to</label>
                        <input
                            type="date"
                            value={localTo}
                            onChange={(e) => setLocalTo(e.target.value)}
                            className="w-full border border-[#D0D5DD] rounded-md px-3 py-2 text-sm"
                        />
                    </div>
                    <div className="flex justify-between gap-2 mt-1">
                        <button onClick={handleClear} className="text-sm text-[#344054]">
                            Clear
                        </button>
                        <button
                            onClick={handleApply}
                            className="bg-[#00305E] text-white text-sm px-4 py-1.5 rounded"
                        >
                            Apply
                        </button>
                    </div>
                </div>
                </div>
            )}
        </div>
    );
}